module.exports = __webpack_public_path__ + "media/images/slide2-d537754d825fd4b6dda62038f36e9890.jpg";